import { useState, useCallback, useEffect } from 'react';
import { CheckCircle, Trash2, MessageSquare } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { leadAPI } from '../../lib/api';
import { toast } from 'sonner';

const LeadsManagement = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLeads = useCallback(async () => {
    try { const res = await leadAPI.getAll(); setLeads(res.data); }
    catch (err) { console.error('Failed to fetch leads:', err); }
    setLoading(false);
  }, []);

  useEffect(() => { fetchLeads(); }, [fetchLeads]);

  const handleDelete = async (id) => {
    if (window.confirm('এই লিড মুছে ফেলতে চান?')) {
      try { await leadAPI.delete(id); toast.success('লিড মুছে ফেলা হয়েছে'); fetchLeads(); }
      catch (err) { toast.error('মুছতে সমস্যা হয়েছে'); }
    }
  };

  return (
    <div>
      <h1 className="text-xl md:text-2xl font-bold text-gray-900 dark:text-white mb-4 md:mb-6">লিড / অনুরোধ</h1>
      {loading ? (
        <div className="animate-pulse space-y-4">{[1, 2, 3].map(i => <div key={i} className="h-32 bg-gray-200 dark:bg-gray-700 rounded-lg" />)}</div>
      ) : leads.length === 0 ? (
        <div className="text-center py-12 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700">
          <MessageSquare className="mx-auto text-gray-400 mb-4" size={48} />
          <p className="text-gray-600 dark:text-gray-400">কোনো লিড নেই</p>
        </div>
      ) : (
        <div className="space-y-4">
          {leads.map((lead) => (
            <div key={lead.id} className="bg-white dark:bg-gray-800 rounded-xl p-4 md:p-6 border border-gray-200 dark:border-gray-700">
              <div className="flex flex-col sm:flex-row justify-between items-start gap-2">
                <div>
                  <h3 className="font-semibold text-gray-900 dark:text-white">{lead.name}</h3>
                  <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">{lead.email} | {lead.phone}</p>
                </div>
                <div className="flex items-center gap-2">
                  {lead.email_sent && (
                    <Badge variant="outline" className="text-green-600 border-green-600 text-xs"><CheckCircle size={12} className="mr-1" /> Email Sent</Badge>
                  )}
                  <span className="text-xs text-gray-400">{new Date(lead.created_at).toLocaleDateString('bn-BD')}</span>
                  <Button variant="ghost" size="sm" onClick={() => handleDelete(lead.id)}><Trash2 size={16} className="text-red-500" /></Button>
                </div>
              </div>
              <p className="mt-3 text-sm text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-gray-700/50 p-3 rounded-lg">{lead.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LeadsManagement;
